(function () {
  'use strict';
  var test = window.LDABZestaw;
  if (!test || !test.decision || test.redirecting) return;
  var nativeFetch = window.fetch.bind(window), syncing = null, exposed = false;
  var attributeKeys = ['ld_ab_zestaw', 'ld_ab_zestaw_experiment', 'ld_ab_zestaw_visitor', 'ld_ab_zestaw_rendered'];
  function allowed() {
    if (test.decision.visualOnly) return false;
    if (test.decision.qa) return true;
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch (_) { return false; }
  }
  function rootPath() { return window.Shopify?.routes?.root || '/'; }
  async function request(path, body) {
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 2500);
    try {
      var options = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } };
      if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
      var response = await nativeFetch(rootPath() + path, options);
      if (!response.ok) throw Error('AB_CART_HTTP_' + response.status);
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  function matches(cart, attributes) { return attributeKeys.every(function (key) { return String(cart.attributes?.[key] || '') === String(attributes[key] || ''); }); }
  function diagnostics(cart) {
    if (!test.decision.qa && !test.clearQA) return;
    var html = document.documentElement;
    html.dataset.ldAbCartState = test.cartState;
    html.dataset.ldAbRendered = test.rendered;
    if (cart) {
      html.dataset.ldAbCartItems = String(cart.item_count);
      html.dataset.ldAbCartTotal = String(cart.total_price);
      var attributes = {}; attributeKeys.forEach(function (key) { if (cart.attributes?.[key]) attributes[key] = cart.attributes[key]; });
      html.dataset.ldAbCartAttributes = JSON.stringify(attributes);
    }
  }
  function ensureCart() {
    if (syncing) return syncing;
    if (!test.decision.variant || !allowed()) return Promise.resolve(false);
    syncing = (async function () {
      test.cartState = 'checking';
      try {
        var attributes = test.orderAttributes(), cart = await request('cart.js');
        if (!matches(cart, attributes)) cart = await request('cart/update.js', { attributes: Object.assign({}, cart.attributes || {}, attributes) });
        if (!matches(cart, attributes)) throw Error('AB_CART_READBACK_MISMATCH');
        test.cartState = 'verified'; test.cartToken = cart.token; diagnostics(cart); return true;
      } catch (error) { test.cartState = 'unverified'; test.cartError = error.name === 'AbortError' ? 'timeout' : error.message; diagnostics(); return false; }
    })().finally(function () { syncing = null; });
    return syncing;
  }
  test.beforeCheckout = async function () { if (syncing) await syncing; return ensureCart(); };
  test.ensureCart = ensureCart;
  function expose() {
    if (exposed || !test.decision.variant || !test.decision.landing || !allowed()) return;
    if (!window.Shopify?.analytics?.publish) return;
    exposed = true;
    try { Promise.resolve(window.Shopify.analytics.publish('ld_ab_zestaw_exposure', { experiment: test.config.experiment, variant: test.orderAttributes().ld_ab_zestaw, visitor: test.record.visitor, rendered: test.rendered })).catch(function () { test.exposureEvent = 'unverified'; }); } catch (_) { test.exposureEvent = 'unverified'; }
  }
  function installForms(scope) {
    if (!test.decision.variant || !allowed()) return;
    var attributes = test.orderAttributes();
    scope.querySelectorAll('form').forEach(function (form) {
      var action;
      try { action = new URL(form.action || '', location.origin); } catch (_) { return; }
      if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
      attributeKeys.forEach(function (key) {
        var name = 'properties[_' + key + ']', input = Array.from(form.elements).find(function (node) { return node.name === name; });
        if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
        if (input.value !== attributes[key]) input.value = attributes[key];
      });
    });
  }
  function moveRecommendations() {
    if (test.rendered !== 'B' || test.config.showRecommendations === false) return;
    var source = document.querySelector('#LdABLandingA [data-ld-ad-slot][data-ld-ad-ready="true"]');
    var target = document.getElementById('LdABRecommendations');
    if (source && target && !target.contains(source)) target.appendChild(source);
  }
  function recommendationsReady() {
    if (test.config.showRecommendations === false || !window.LDAdContext?.code || window.LDAdContext.expired) return Promise.resolve();
    var state = document.querySelector('#LdABLandingA [data-ld-collection]')?.dataset.ldAdState;
    if (state === 'ready' || state === 'empty') return Promise.resolve();
    return new Promise(function (resolve) {
      var timer = setTimeout(done, 6500);
      function done() { clearTimeout(timer); document.removeEventListener('ld:ad:release', done); resolve(); }
      document.addEventListener('ld:ad:release', done, { once: true });
    });
  }
  async function activateB() {
    if (test.aborted) return;
    var template = document.getElementById('LdABLandingTemplate'), target = document.getElementById('LdABLandingB');
    if (!template || !target) { test.markRendered('A-fallback'); delete document.documentElement.dataset.ldAbLanding; return; }
    var fragment = template.content.cloneNode(true), scripts = Array.from(fragment.querySelectorAll('script[src]'));
    var existing = new Set(Array.from(document.querySelectorAll('script[src]')).map(function (script) { return script.src; }));
    scripts.forEach(function (script) { script.remove(); });
    target.appendChild(fragment);
    try {
      for (var script of scripts) {
        if (test.aborted) throw Error('AB_STARTUP_TIMEOUT');
        if (existing.has(script.src)) continue;
        var url = new URL(script.src, location.href);
        if (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com') throw Error('AB_ASSET_ORIGIN');
        await new Promise(function (resolve, reject) {
          var node = document.createElement('script'); node.src = url.href; node.async = false;
          var timer = setTimeout(function () { reject(Error('AB_ASSET_TIMEOUT')); }, 8000);
          node.onload = function () { clearTimeout(timer); resolve(); };
          node.onerror = function () { clearTimeout(timer); reject(Error('AB_ASSET_LOAD')); };
          document.body.appendChild(node);
        });
        existing.add(url.href);
      }
      if (!target.querySelector('ld-set-builder[data-builder-ready="true"]')) throw Error('AB_BUILDER_NOT_READY');
      await recommendationsReady();
      if (test.aborted) throw Error('AB_STARTUP_TIMEOUT');
      test.markRendered('B');
      target.hidden = false;
      document.getElementById('LdABLoading')?.remove();
      moveRecommendations();
      target.dataset.ldAbReady = 'true';
      document.dispatchEvent(new CustomEvent('ld:ab:rendered', { detail: { variant: 'B' } }));
    } catch (error) {
      test.renderError = error.message; test.markRendered('A-fallback'); target.hidden = true;
      delete document.documentElement.dataset.ldAbLanding;
    }
  }
  async function clearQA() {
    try {
      var cart = await request('cart.js');
      if (!/^QA-[AB]$/.test(cart.attributes?.ld_ab_zestaw || '') || cart.attributes?.ld_ab_zestaw_experiment !== test.config.experiment) { test.cartState = 'qa-cleared'; diagnostics(cart); return; }
      var attributes = Object.assign({}, cart.attributes); attributeKeys.forEach(function (key) { attributes[key] = ''; });
      var cleaned = await request('cart/update.js', { attributes: attributes }); test.cartState = 'qa-cleared'; diagnostics(cleaned);
    } catch (_) { test.cartState = 'qa-clear-unverified'; }
  }
  function trackMutations() {
    if (!test.decision.variant || test.decision.visualOnly) return;
    window.fetch = async function (input, init) {
      var response = await nativeFetch(input, init), url;
      try { url = new URL(typeof input === 'string' || input instanceof URL ? String(input) : input.url, location.href); } catch (_) { return response; }
      var method = String(init?.method || input?.method || 'GET').toUpperCase();
      if (response.ok && method !== 'GET' && url.origin === location.origin && /\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(url.pathname)) void ensureCart();
      return response;
    };
  }
  async function boot() {
    if (test.clearQA) { await clearQA(); return; }
    if (test.decision.landing && test.decision.variant === 'B') await activateB();
    else test.markRendered('A');
    if (!test.decision.variant || test.decision.visualOnly) return;
    trackMutations(); installForms(document); expose(); void ensureCart();
    var formTimer;
    new MutationObserver(function (changes) {
      if (!changes.some(function (change) { return change.addedNodes.length; })) return;
      clearTimeout(formTimer); formTimer = setTimeout(function () { installForms(document); }, 60);
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('visitorConsentCollected', function () { installForms(document); expose(); void ensureCart(); });
    document.addEventListener('ld:ad:ready', moveRecommendations);
    document.addEventListener('click', function (event) {
      var anchor = event.target.closest('a[href]');
      if (!anchor || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var url = new URL(anchor.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname !== location.pathname || url.search !== location.search) test.clearLanding();
      if (anchor.target === '_blank' || !/\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname)) return;
      event.preventDefault(); void ensureCart().then(function () { location.assign(url.href); });
    }, true);
    var submitting = new WeakSet();
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || submitting.has(form)) return;
      if (event.submitter?.name !== 'checkout' && !/\/(?:checkout|checkouts)(?:\/|$)/.test(new URL(form.action, location.href).pathname)) return;
      event.preventDefault(); var submitter = event.submitter;
      void ensureCart().then(function () { submitting.add(form); form.requestSubmit(submitter || undefined); submitting.delete(form); });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else void boot();
})();
